import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "../Navbar";
import Footer from "../Footer";

const Layout = () => {
  return (
    <>
      <div className="left-content">
        <Navbar />
      </div>
      <div className="right-content">
        <Outlet />
        <Footer />
      </div>
    </>
  );
};

export default Layout;